<template>
    <div class="formitem">
        <a-card>
            <template slot="title">
                <v-gobackbutton>返回</v-gobackbutton>请填写表单内容
            </template>
            <a-form @submit="handleSubmit" layout="inline" :form="form">
                <a-row>
                    <a-form-item label="服务key">
                        <a-input
                            placeholder="请输入服务key"
                            style="width:300px"
                            :disabled="this.$route.query.id ? true : false"
                            v-decorator="[
                                'servicekey',
                                {
                                    initialValue: record.servicekey,
                                    rules: [{ required: false, message: '请输入服务key' }]
                                }
                            ]"
                        />
                    </a-form-item>
                </a-row>
                <a-row>
                    <a-form-item label="触发条件">
                        <a-input
                            style="width:300px"
                            v-decorator="[
                                'rulecontent',
                                {
                                    initialValue: record.rulecontent ? record.rulecontent : 'RC_HTTP_1M_COUNT > 10',
                                    rules: [{ required: true, message: '请输入触发条件' }]
                                }
                            ]"
                        />
                    </a-form-item>
                </a-row>
                <a-row>
                    <a-form-item label="规则类型">
                        <a-select
                            style="width:195px"
                            v-decorator="[
                                'ruletype',
                                {
                                    initialValue: record.ruletype ? record.ruletype : '0',
                                    rules: [{ required: true, message: '请输入规则类型' }]
                                }
                            ]"
                        >
                            <a-select-option key="0">HTTP接口</a-select-option>
                        </a-select>
                    </a-form-item>
                </a-row>

                <a-row>
                    <a-form-item label="名单时间">
                        <a-input
                            v-decorator="[
                                'nlinterval',
                                {
                                    initialValue: record.nlinterval || '1d',
                                    rules: [{ required: true, message: '请输入名单时间' }]
                                },
                            ]"
                        ></a-input>
                    </a-form-item>
                    <a-form-item>
                        d-天 h-小时 m-分钟   如: 1d、8h、30m
                    </a-form-item>
                </a-row>

                <a-row>
                    <a-form-item label="名单类型">
                        <a-select
                            style="width:160px"
                            v-decorator="[
                                'nltype',
                                {
                                    initialValue: record.nltype || [],
                                    rules: [{ required: true, message: '请选择名单类型' }]
                                }
                            ]"
                            placeholder="选择名单类型"
                        >
                            <a-select-option key="0">黑名单</a-select-option>
                            <a-select-option key="1">白名单</a-select-option>
                            <a-select-option key="2">接口黑名单</a-select-option>
                            <a-select-option key="3">接口白名单</a-select-option>
                        </a-select>
                    </a-form-item>
                </a-row>

                <a-row>
                    <a-form-item label="加入名单">
                        <a-radio-group
                            v-decorator="[
                                'nlflag',
                                {
                                    initialValue: record.nlflag || '1',
                                }
                            ]"
                        >
                            <a-radio value="1">是</a-radio>
                            <a-radio value="0">否</a-radio>
                        </a-radio-group>
                    </a-form-item>
                </a-row>

                <a-row>
                    <a-form-item label=" " :colon="false">
                        <a-button
                            :disabled="disabled"
                            :key="this.loading.key"
                            :loading="this.loading.effects[addType] || this.loading.effects[editType]"
                            type="primary"
                            htmlType="submit"
                        >保存</a-button>
                        <v-resetbutton :disabled="disabled" class="ml20">重填</v-resetbutton>
                    </a-form-item>
                </a-row>
            </a-form>
        </a-card>
    </div>
</template>

<script>
// import { mapGetters } from "vuex";
import { mapState } from "vuex";

const storeNamespace = "rc";

export default {
    data() {
        return {
            formLayout: "horizontal",
            form: this.$form.createForm(this),
            storeNamespace,
            addType: `${storeNamespace}/add`,
            editType: `${storeNamespace}/edit`,
            detailType: `${storeNamespace}/detail`,

            action: this.$route.params.action,
            disabled: this.$route.params.action == "detail" ? true : false //查看详情的时候禁用编辑框 跟 按钮
        };
    },
    computed: {
        ...mapState(storeNamespace, {
            record: function(state) {
                //这里需要注意 this 指向问题, 如果用箭头函数, 会有this作用域的问题
                return this.action == "add" ? {} : state.record;
            }
        })
    },
    methods: {
        //新增
        add(values) {
            this.$store
                .dispatch({
                    type: this.addType,
                    params: values
                })
                .then(() => {
                    this.$router.push({
                        path: "list"
                    });
                });
        },
        //修改
        edit(values) {
            values.id = this.record.id;
            this.$store
                .dispatch({
                    type: this.editType,
                    params: values
                })
                .then(() => {
                    this.$router.push({
                        path: "list",
                        query: JSON.parse(this.$route.query.referer)
                    });
                });
        },
        //表单提交
        handleSubmit(e) {
            e.preventDefault();
            this.form.validateFields((err, values) => {
                if (err) return;
                //根据路由的action, 动态绑定 新增 或 修改操作
                this[this.action](values);
            });
        }
    },
    mounted() {
        const { query, params } = this.$route;

        if (params.action != "add") {
            this.$store.dispatch({
                type: this.detailType,
                params: query
            });
        }
    }
};
</script>

<style scoped>
</style>
